import { memo } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import useAppDownloadLinks from 'Hooks/useAppDownloadLinks';

import appleStoreIcon from 'Assets/images/app-download/en/apple.png';
import googlePlayIcon from 'Assets/images/app-download/en/google.png';

import AppLink from './AppLink';

const getImageByLanguageCode = (locale: string, type: string) => {
  const isApple = type === 'apple';
  try {
    // eslint-disable-next-line import/no-dynamic-require
    return require(`Assets/images/app-download/${locale}/${
      isApple ? 'apple' : 'google'
    }.png` /* webpackMode: "lazy-once" */).default;
  } catch (e) {
    return isApple ? appleStoreIcon : googlePlayIcon;
  }
};

type Props = {
  className?: string;
  titleId?: string;
  buttonClassName?: string;
  showAppleStore?: boolean;
  showPlayStore?: boolean;
};

const NativeAppsLinks = (props: Props) => {
  const { className, buttonClassName, showAppleStore = true, showPlayStore = true } = props;

  const { formatMessage, locale } = useIntl();
  const { androidLink, iOSLink } = useAppDownloadLinks();

  const singleLink = showAppleStore !== showPlayStore;

  return (
    <div className={classNames('Ta(c)', className)} data-testid="nativeAppsLinks">
      <div
        className={classNames('D(f) M(a) Ai(c)', {
          'Jc(sb)--s Jc(c)--ml': !singleLink,
          'Jc(c)': singleLink,
        })}
      >
        {showAppleStore && (
          <AppLink
            href={iOSLink}
            message="NativeAppsLinks - Download iOS App"
            image={getImageByLanguageCode(locale, 'apple')}
            itemProp="relatedLink"
            intlMessage={formatMessage({ id: 'NavMenu.downloadIos' })}
            buttonClassName={classNames(buttonClassName, 'Fxb(1/2)')}
            data-testid="NativeAppsLinks.IOS"
            imageClassName="H(48px)"
          />
        )}
        {showPlayStore && (
          <AppLink
            href={androidLink}
            message="NativeAppsLinks - Download Android App"
            image={getImageByLanguageCode(locale, 'google')}
            itemProp="relatedLink"
            intlMessage={formatMessage({ id: 'NavMenu.downloadAndroid' })}
            buttonClassName={classNames(buttonClassName, 'Fxb(1/2)')}
            data-testid="NativeAppsLinks.Android"
            imageClassName="H(80px)"
          />
        )}
      </div>
    </div>
  );
};

export default memo(NativeAppsLinks);
